@if (canDisplayStatus) {
  <div>
    <i-title text="Tableau kanban"></i-title>
    @if (configStatus.length > 0) {
      <div class="row mt-4 mb-4 d-flex align-items-center">
        <input
          type="text"
          class="form-control super-compos-search-field w-auto pe-5 ps-5 pb-3 ms-3"
          [placeholder]="'homeCourrier.searchCourrier' | translate"
          [(ngModel)]="searchString" />
      </div>
    }
    <div cdkDropListGroup class="row kanban__container flex-nowrap">
      @for (status of selectedStatus | sort: 'displayOrder'; track status) {
        <div class="kanban" [ngClass]="{ 'd-none': status.documentstatus && status.documentstatus.length === 0 }">
          <div class="kanban__header" id="navBar"></div>
          <div class="kanban__col">
            @if (status.documentstatus && status.documentstatus.length > 0) {
              <div class="d-flex flex-column align-items-center" style="height: 70vh">
                @for (subcol of status.documentstatus; track subcol; let i = $index) {
                  <div
                    class="kanban__subcol"
                    [ngStyle]="{ 'border-color': subcol?.color }"
                    id="{{ i }}"
                    [ngClass]="{ 'kanban__subcol--open': i === expandID }">
                    <i class="bi bi-arrows-vertical kanban__expand me-4" (click)="expand(i)"></i>
                    <h4 class="kanban__title status_title">{{ subcol?.description }}({{ myItems_by_status[+status.id][+subcol.id]?.length }})</h4>
                    @if (myItems_by_status[+status.id]) {
                      <div
                        [id]="subcol.id"
                        class="kanban__list"
                        cdkDropList
                        [cdkDropListData]="myItems_by_status[+status.id] | filter: 'status' : subcol.id"
                        (cdkDropListDropped)="dropSubContainer($event)">
                        @for (item of myItems_by_status[+status.id][+subcol.id] | searchByKey: 'objet' : searchString; track item) {
                          <div>
                            @if (item) {
                              <div cdkDrag class="kanban__box">
                                <div class="cdk-placeholder" *cdkDragPlaceholder></div>
                                <div class="d-flex align-items-center justify-content-between">
                                  <div class="kanban__service" pTooltip="{{ item?.serviceProprietaire?.description }}" tooltipPosition="bottom">
                                    {{
                                      item?.serviceProprietaire?.description
                                        ? (item?.serviceProprietaire?.description | maxLength: 35)
                                        : 'Pas de service'
                                    }}
                                  </div>
                                  @if (item?.typeEntrantSortant === 'E') {
                                    <i class="icons-courrier_type_entrant_from_global_SCSS icon kanban__icon"></i>
                                  }
                                  @if (item?.typeEntrantSortant === 'I') {
                                    <i class="icons-courrier_type_interne_from_global_SCSS icon kanban__icon"></i>
                                  }
                                  @if (item?.typeEntrantSortant === 'S') {
                                    <i class="icons-courrier_type_sortant_from_global_SCSS icon kanban__icon"></i>
                                  }
                                </div>
                                <div class="kanban__label" (click)="openMail(item)" [pTooltip]="item.objet" tooltipPosition="bottom">
                                  {{ item?.objet ? (item?.objet | maxLength: 50) : 'Courrier sans objet' }}
                                </div>
                                <div class="d-flex align-items-center justify-content-between">
                                  <span
                                    class="kanban__date"
                                    pTooltip="Date d'échéance"
                                    [ngClass]="{ 'text-danger': item?.danger, 'text-warning': item?.warning }"
                                    tooltipPositon="bottom"
                                    >{{ item?.dateEcheance | momentFormat: 'DD/MM/YYYY' }}</span
                                  >
                                </div>
                              </div>
                            }
                          </div>
                        }
                      </div>
                    }
                  </div>
                }
              </div>
            }
            @if (status.documentstatus && status.documentstatus.length === 0) {
              <div>
                <img src="./assets/img/loupe-loader.gif" class="img-fluid" alt="" />
              </div>
            }
          </div>
        </div>
      }
    </div>
  </div>
} @else {
  <div class="noResult-visible">
    <img src="./assets/img/decoration/noresult.svg" width="300" height="300" alt="" />
    <p class="ww-page-title">{{ 'homeCourrier.noStatusPrompt' | translate }}</p>
  </div>
}

<ng-template #noResult>
  <div class="noResult-visible">
    <img src="./assets/img/decoration/noresult.svg" width="300" height="300" alt="" />
    <p class="ww-page-title">{{ 'homeCourrier.noStatusPrompt' | translate }}</p>
  </div>
</ng-template>
<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="square-jelly-box" [fullScreen]="true"
  ><p style="color: white">{{ 'loading' | translate }}</p></ngx-spinner
>
